import { GlobalSearchCategorySchema } from "@redotech/redo-model/global-search/global-search-category";
import { RedoDocumentationSchema } from "@redotech/redo-model/redo-documentation";
import { SortDirection } from "@redotech/redo-model/tables/table";
import * as z from "zod/v4";

export const getGlobalSearchResults = {
  name: "getGlobalSearchResults" as const,
  input: z.object({
    category: GlobalSearchCategorySchema.optional(),
    enabled: z.boolean().optional(),
    searchText: z.string().optional(),
    sortKey: z.enum(["title", "priority", "createdAt", "updatedAt"]).optional(),
    sortDirection: z.enum(SortDirection).optional(),
    limit: z.number().int().min(1).max(100).optional(),
    skip: z.number().int().min(0).optional(),
  }),
  output: z.object({
    results: z.array(RedoDocumentationSchema),
    total: z.number().int(),
  }),
};
